export default __webpack_public_path__ + "static/media/Image.774df7eb.jpg";